import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import { useAuthStore } from '@/store/auth' 

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)   
app.use(vuetify)
app.use(router)

// Now it's safe to call useAuthStore()
router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  if (!to.meta.public && !auth.isAuthenticated) next('/login')
  else next()
})


app.mount('#app')